import { useAuth } from '../../../utils/Auth';
import { saveNicknameData } from '../../../utils/QRFunctions/qrActions';
import styles from './Nickname.module.css';

export default function Nickname(props) {
    const { reference } = props;
    const { qr_data, dataDispatch } = useAuth();

    const handleNickname = (e) => {
        const newNickname = e.target.value;
        dataDispatch({ type: 'nickname', data: newNickname });

        if (reference !== 'new' && (qr_data?.id.includes('-') && qr_data?.data.created_at)) {
            saveNicknameData(qr_data?.id, newNickname, qr_data.data);
        }
    };

    return (
        <div className={styles.inputGroup}>
            <input type='text' id='nickame-label' className={styles.input} maxLength='100' onChange={handleNickname} value={qr_data?.data?.nickname} />
            <label htmlFor='nickame-label' className={styles.label}>QR Nickname</label>
            {!qr_data?.data?.nickname && (<div className={styles.required}>* Required</div>)}
        </div>
    );
};
